// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__hCWfq","projectCard":"Projects_projectCard__SgbxN"};